import { render } from "./RenameTemplateModal.vue?vue&type=template&id=08a9a78a&scoped=true"
import script from "./RenameTemplateModal.vue?vue&type=script&lang=js"
export * from "./RenameTemplateModal.vue?vue&type=script&lang=js"

import "./RenameTemplateModal.vue?vue&type=style&index=0&id=08a9a78a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a9a78a"]])

export default __exports__